<div class="view-loader" (click)="handleClick()" #viewLoader>
  <ng-content></ng-content>
</div>